import dayjs from 'dayjs';
import { MRT_ColumnDef, MRT_RowData } from 'mantine-react-table';
import { QUEUE_EMPTY_COLOR, QUEUE_OK_COLOR, TwoLineCell } from '../../components/QueueCells';

interface WonRowLike extends MRT_RowData {
  wonAt?: string;
  procedureAppointment?: { start?: string };
}

const CLOSED_SIZE = 76;
const PROCEDURE_SCHEDULED_SIZE = 130;

/** The Won date. */
export function closedColumn<Row extends WonRowLike>(): MRT_ColumnDef<Row> {
  return {
    id: 'closed',
    header: 'Closed',
    size: CLOSED_SIZE,
    accessorFn: (row) => row?.wonAt ?? '',
    sortingFn: 'datetime',
    Cell: ({ row }) => {
      const wonAt = row.original?.wonAt;
      return (
        <TwoLineCell
          primary={wonAt ? dayjs(wonAt).format('MMM D') : <span style={{ color: QUEUE_EMPTY_COLOR }}>—</span>}
        />
      );
    },
  };
}

/** A green tick and the date once an index procedure is booked, amber otherwise. */
export function procedureScheduledColumn<Row extends WonRowLike>(): MRT_ColumnDef<Row> {
  return {
    id: 'procedureScheduled',
    header: 'Procedure scheduled',
    size: PROCEDURE_SCHEDULED_SIZE,
    enableSorting: false,
    Cell: ({ row }) => {
      const appointment = row.original?.procedureAppointment;
      if (!appointment) {
        return <TwoLineCell primary="✗ Not scheduled" primaryEmphasis="warning" />;
      }
      const date = appointment.start ? ` ${dayjs(appointment.start).format('MMM D')}` : '';
      return <TwoLineCell primary={<span style={{ color: QUEUE_OK_COLOR }}>{`✓${date}`}</span>} />;
    },
  };
}
